import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { VisitorAgreement } from '../visitor-invite/visitor-invite.component';
import { UserRegDetails } from 'src/app/models/user';
import { ScreenType } from 'src/app/enums/ScreenType';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Visitor } from 'src/app/models/visitor';
import {
  Observable,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  startWith,
  tap,
} from 'rxjs';
import { VisitorType } from 'src/app/enums/visitor';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MapsLocationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/maps-location-dialog/maps-location-dialog.component';
import { environment } from 'src/app/environments/environments';
import { ChangeDetectorRef } from '@angular/core';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
@Component({
  selector: 'app-visitor-invite-form',
  templateUrl: './visitor-invite-form.component.html',
  styleUrls: ['./visitor-invite-form.component.scss'],
})
export class VisitorInviteFormComponent implements OnInit {
  @ViewChild('hostInput') hostInput: ElementRef<HTMLInputElement>;
  @Output() onCreateNewVisitor = new EventEmitter();
  @Output() onCancelVisitorInvite = new EventEmitter();
  @Output() onUpdateVisitor = new EventEmitter();
  @Input() hostLists: UserRegDetails[];
  @Input() set visitorList(val: Visitor[]) {
    if (val) {
      this.filteredVisitorList = val;
      const visitorMap = new Map<string, Visitor>();
      val.forEach((visitor) => {
        if (
          visitor.visitorType === VisitorType.PreVerified.toString() &&
          !visitorMap.has(visitor.visitorID)
        ) {
          visitorMap.set(visitor.visitorID, visitor);
        }
      });
      this.customFilteredList = Array.from(visitorMap.values());
    }
  }
  @Input() set selectedDate(val: Date) {
    this.currentYear = val.getFullYear();
    this.minDate = new Date(
      this.currentYear + 0,
      val.getMonth(),
      val.getDate()
    );
    const minDate = new Date(val);
    minDate.setDate(minDate.getDate() + 1); // Add 1 day
    this.minPassValidityDate = minDate;
    this.maxDate = new Date(this.currentYear + 0, new Date().getMonth() + 6, 0);
  }
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  customFilteredList: Visitor[] = [];
  filteredVisitorList: Visitor[];
  VisitorType = VisitorType;
  filteredVisitor: Observable<Visitor[]>;
  hostFilter = new FormControl();
  selectedHosts: UserRegDetails[] = [];
  filteredHosts: UserRegDetails[] = [];
  isShowPreview = false;
  screenInfo: ScreenType;
  urlProfile = '';
  urlID = '';
  showPreview: boolean;
  minDate: any;
  minPassValidityDate: Date | null = null;
  maxDate: any;
  currentYear: number;
  visitorCtrl = new FormControl('');
  baseServerURL = environment.apiUrl;
  printerAllowed = environment.printerAllowed;
  constructor(
    private _formbuilder: FormBuilder,
    public _dialog: MatDialog,
    private httpclient: HttpClient,
    private cdRef: ChangeDetectorRef,
    private encryptionService: EncryptionService
  ) {}
  OrgId: string = null;
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });

  createNewVisitorForm = this._formbuilder.group({
    visitorId: [''],
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    email: ['', [Validators.email]],
    phoneNumber: ['', [Validators.required]],
    visitorAddress: [''],
    purpose: [''],
    carRegistration: [''],
    identityID: [''],
    hostUserId: [''],
    securityStatus: [0],
    hostName: [''],
    profilePicture: [''],
    department: [''],
    ePassValidity: ['', Validators.required],
    visitorCategory: ['', Validators.required],
    selectedHosts: this._formbuilder.array([], Validators.required),
    isReVisit: [false, Validators.required],
    visitorTimline: [''],
    requestVerification: [false],
    completeStatusTime: [''],
    inProgressStatusTime: [''],
    isVerified: [false],
    isLocationVerify: [false],
    isTwoFactor: [false],
    visitorLocation: [null],
  });
  isEnable = false;
  isUniqueVisitor = true;
  isValid = true;
  visitors: Visitor[] = [];
  isDisabled = true;
  private phoneInputSubscription: Subscription | null = null;
  ngOnInit() {
    this.OrgId = this.encryptionService.getCurrentUser().organizationID;
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
    this.isDisabled = true;
    // this.phoneForm.get('phone')?.valueChanges.subscribe((value) => {
    //   if (this.phoneForm.get('phone')?.valid) {
    //     if (
    //       this.visitors.length == 0 ||
    //       (this.visitors.length > 0 &&
    //         this.phoneForm.get('phone').value != this.visitors[0].phoneNumber)
    //     ) {
    //       this.isEnable = true;
    //       this.checkPhoneNumber(value);
    //     } else {
    //       this.createNewVisitorForm.reset();
    //     }
    //   } else {
    //     this.isUniqueVisitor = true;
    //   }
    // });
    this.phoneInputSubscription = this.phoneForm
      .get('phone')
      ?.valueChanges.pipe(
        debounceTime(500), // Wait 500ms for user input to stabilize
        distinctUntilChanged(), // Prevent duplicate calls for the same input
        filter(() => this.phoneForm.get('phone')?.valid), // Only valid inputs proceed
        tap(() => {
          if (!this.phoneForm.get('phone')?.valid) {
            this.resetFields();
          }
        }), // Reset fields before making API call
        tap((phoneNumber) => {
          this.checkPhoneNumber(phoneNumber);
        }) // Call the void function
      )
      .subscribe();
    this.phoneForm.get('phone')?.valueChanges.subscribe((value) => {
      if (!this.phoneForm.get('phone')?.valid) {
        this.resetFields();
      }
    });
    this.createNewVisitorForm.disable();
    this.filteredHosts = this.hostLists.filter((x) => x.userRole != 'kiosk');
    const isLocationVerify = this.createNewVisitorForm.get('isLocationVerify');
    if (isLocationVerify) {
      isLocationVerify.valueChanges.subscribe((x) => {
        const visitorLocation =
          this.createNewVisitorForm.get('visitorLocation');
        if (x) {
          visitorLocation.setValidators([Validators.required]);
        } else {
          visitorLocation.clearValidators();
        }
        visitorLocation.updateValueAndValidity();
      });
    }

    // Subscribe to value changes in the filter input
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredHosts = this.filterHosts(value);
    });
    this.selectedUsersControl.valueChanges.subscribe((value) => {
      this.filteredHosts = this.filterHosts(value);
    });
    this.filteredVisitor = this.visitorCtrl.valueChanges.pipe(
      startWith(''),
      map((visitor) =>
        visitor ? this._filterStates(visitor) : this.customFilteredList.slice()
      )
    );
  }
  private _filterStates(value: string): Visitor[] {
    const filterValue = value.toLowerCase();

    return this.customFilteredList.filter((visitor) =>
      visitor.firstName.toLowerCase().includes(filterValue)
    );
  }
  resetFields(): void {
    this.createNewVisitorForm.reset();
    this.createNewVisitorForm.disable();
    this.isDisabled = true;
    this.isEnable = false;
    this.isUniqueVisitor = true;
    this.isValid = true;
    this.isEnable = false;
    this.showField = true;
    const formArray = this.createNewVisitorForm.get(
      'selectedHosts'
    ) as FormArray;
    formArray.clear();
    this.usersTemp = [];
    this.createNewVisitorForm.controls.identityID.setValue('');
    this.createNewVisitorForm.controls.profilePicture.setValue('');
    this.createNewVisitorForm.controls.isTwoFactor.setValue(false);
    this.createNewVisitorForm.controls.isVerified.setValue(false);
    this.createNewVisitorForm.controls.isLocationVerify.setValue(false);
    this.createNewVisitorForm.controls.isReVisit.setValue(false);
  }
  checkPhoneNumber(phoneNumber: string): void {
    let baseServerURL = this.baseServerURL + 'CheckExistingVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .get(
        `${baseServerURL}?Number=${phoneNumber}&OrgId=${this.OrgId}&Type=2`,
        httpOptions
      )
      .subscribe(
        (response: any) => {
          this.createNewVisitorForm.reset();
          if (response.exists) {
            if (response.isValid) {
              this.isUniqueVisitor = false;
              this.isValid = response.isValid;
              this.visitors = response.visitor;
              this.createNewVisitorForm.controls.isVerified.disable();
              this.setInputField();
            } else {
              this.visitors = [];
              this.visitors = response.visitor;
              this.isUniqueVisitor = false;
              this.isValid = false;
              this.createNewVisitorForm.controls.isVerified.disable();
            }
          } else {
            this.createNewVisitorForm.enable();
            this.isUniqueVisitor = true;
            this.isDisabled = false;
            this.visitors = [];
            this.createNewVisitorForm.controls.requestVerification.setValue(
              false
            );
            this.showField = true;
            this.createNewVisitorForm.controls.isTwoFactor.setValue(false);
            this.createNewVisitorForm.controls.isVerified.setValue(false);
            this.createNewVisitorForm.controls.isLocationVerify.setValue(false);
            this.createNewVisitorForm.controls.isReVisit.setValue(false);
            this.createNewVisitorForm.controls.phoneNumber.setValue(
              this.phoneForm.value.phone
            );
          }
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  filterHosts(value: string) {
    // Implement your filtering logic here
    const filterValue = value.toLowerCase();
    return this.hostLists.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  onOptionSelected(val: MatAutocompleteSelectedEvent) {
    //this.createNewVisitorForm.controls.hostUserId.setValue(val.option.value);
    this.filteredHosts.forEach((item) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.createNewVisitorForm.controls.hostUserId.setValue(item.userId);
      }
    });
  }
  updateFormControlValue(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.createNewVisitorForm.controls.firstName.setValue(value);
  }
  visitorSelect(val: Visitor[]) {
    // const visitorId = val.option.value;
    const visitor: Visitor[] = val;
    const formArray = this.createNewVisitorForm.get(
      'selectedHosts'
    ) as FormArray;
    this.usersTemp = [];
    formArray.clear();
    this.createNewVisitorForm.controls.requestVerification.setValue(false);
    this.createNewVisitorForm.controls.firstName.setValue(visitor[0].firstName);
    this.createNewVisitorForm.controls.lastName.setValue(visitor[0].lastName);
    this.createNewVisitorForm.controls.email.setValue(visitor[0].email);
    this.createNewVisitorForm.controls.phoneNumber.setValue(
      visitor[0].phoneNumber
    );
    this.createNewVisitorForm.controls.visitorAddress.setValue(
      visitor[0].visitorAddress
    );
    // this.createNewVisitorForm.controls.ePassValidity.setValue(
    //   visitor[0].ePassValidity
    // );
    this.createNewVisitorForm.controls.isTwoFactor.setValue(false);
    // this.createNewVisitorForm.controls.isVerified.setValue(true);

    this.createNewVisitorForm.controls.isLocationVerify.setValue(false);
    // this.createNewVisitorForm.controls.visitorLocation.setValue(
    //   visitor[0].visitorLocation
    // );
    // this.createNewVisitorForm.controls.purpose.setValue(visitor[0].purpose);
    // this.createNewVisitorForm.controls.hostUserId.setValue(visitor.hostUserId);
    // this.createNewVisitorForm.controls.hostName.setValue(visitor.hostName);
    // this.createNewVisitorForm.controls.visitorCategory.setValue(
    //   visitor[0].visitorCategory == 'Rapid Visitor'
    //     ? ''
    //     : visitor[0].visitorCategory
    // );
    this.urlProfile = visitor[0].profilePicture;
    this.urlID = visitor[0].identityID;
    if (
      this.urlProfile &&
      this.urlID &&
      this.urlProfile.length >= 10 &&
      this.urlID.length >= 10
    ) {
      this.isFaceMatched = true;
    }

    // this.hostFilter.setValue(`${visitor.hostName}`);
    // this.visitorCtrl.setValue(`${visitor[0].firstName}`);
    this.createNewVisitorForm.controls.isReVisit.setValue(true);
    this.createNewVisitorForm.controls.visitorId.setValue(visitor[0].visitorID);
    this.createNewVisitorForm.controls.visitorTimline.setValue(
      visitor[0].visitorTimline
    );
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onShowPreview() {
    this.isShowPreview = !this.isShowPreview;
  }
  uploadProgressId = 0;
  uploadProgressProfile = 0;
  profilePicFile: any;
  onUploadProfile(event: any) {
    this.profilePicFile = event.target.files[0];
    const file = event.target.files[0];

    if (file) {
      var reader = new FileReader();

      // Show progress during load
      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          this.uploadProgressProfile = Math.round((e.loaded / e.total) * 100);
          // Force change detection
          this.cdRef.detectChanges();
        }
      };

      reader.onload = (event: any) => {
        this.uploadProgressProfile = 100;
        this.urlProfile = event.target.result;
        this.createNewVisitorForm.value.profilePicture = this.urlProfile;
        // Force change detection
        this.cdRef.detectChanges();
      };

      reader.readAsDataURL(file);
    }
  }
  urlIdFile: any;
  onUploadID(event: any) {
    this.urlIdFile = event.target.files[0];
    const file = event.target.files[0];

    if (file) {
      var reader = new FileReader();

      // Show progress during load
      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          this.uploadProgressId = Math.round((e.loaded / e.total) * 100);
          // Force change detection
          this.cdRef.detectChanges();
        }
      };

      reader.onload = (event: any) => {
        this.uploadProgressId = 100;
        this.urlID = event.target.result;
        this.createNewVisitorForm.value.identityID = this.urlID;
        // Force change detection
        this.cdRef.detectChanges();
      };

      reader.readAsDataURL(file);
    }
  }
  onNotify() {
    this.showPreview = !this.showPreview;
  }
  openDialog() {
    const dialogRef = this._dialog.open(VisitorAgreement);

    dialogRef.afterClosed().subscribe((result) => {});
  }
  onSendInvite() {
    this.createNewVisitorForm.controls.identityID.setValue('');
    this.createNewVisitorForm.controls.profilePicture.setValue('');
    this.createNewVisitorForm.controls.identityID.setValue(this.urlID);
    this.createNewVisitorForm.controls.profilePicture.setValue(this.urlProfile);
    this.createNewVisitorForm.controls.securityStatus.setValue(
      this.isManuallyVerify ? 11 : 0
    );
    this.onCreateNewVisitor.emit(this.createNewVisitorForm.value);
  }
  showMsg = false;
  isAPIRequest = false;
  isFaceMatched = false;
  isRetry = false;
  faceMatchMsg = '';
  isManuallyVerify = false;
  showField = true;
  onManuallyVerifyVisitor() {
    this.isManuallyVerify = true;
    this.isRetry = false;
    this.onSelfVerifyVisitor();
  }
  onSelfVerifyVisitor() {
    this.showMsg = true;
    this.isAPIRequest = true;
    let baseServerURL = this.baseServerURL + 'NewFaceRecognition';
    const formData = new FormData();
    formData.append('IdentityId', this.urlIdFile, this.urlIdFile.name);
    formData.append(
      'ProfilePic',
      this.profilePicFile,
      this.profilePicFile.file
    );
    formData.append(
      'Name',
      this.createNewVisitorForm.controls.firstName.value +
        ' ' +
        this.createNewVisitorForm.controls.lastName.value
    );
    formData.append(
      'isManuallyVerify',
      this.isManuallyVerify ? 'true' : 'false'
    );
    this.httpclient
      .post(baseServerURL, formData, { responseType: 'text' })
      .subscribe(
        (response: any) => {
          try {
            const res = JSON.parse(response);
            this.faceMatchMsg = res.message;
            this.urlID = res.identityId;
            this.urlProfile = res.profile;
            this.isFaceMatched = true;
            this.cdRef.detectChanges();
          } catch (e) {
            console.error('Error parsing response:', e);
            this.faceMatchMsg = 'Invalid response from server.';
            this.isFaceMatched = false;
            this.cdRef.detectChanges();
          } finally {
            this.isAPIRequest = false;
            this.isRetry = false;
            this.cdRef.detectChanges();
          }
        },
        (err) => {
          console.error('API call failed:', err);
          this.isRetry = true;
          this.faceMatchMsg = err.error || 'An error occurred.';
          this.isAPIRequest = false;
          this.isFaceMatched = false;
          this.cdRef.detectChanges();
        }
      );
  }
  onCancel() {
    this.onCancelVisitorInvite.emit();
  }
  selectedUsersControl = new FormControl();
  usersTemp: string[] = [];
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.hostLists.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this._formbuilder.control(item));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.createNewVisitorForm.get(
      'selectedHosts'
    ) as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
  get selected() {
    return this.createNewVisitorForm.get('selectedHosts') as FormArray;
  }
  getCustomPhoneNumber(val: string): string {
    if (val && val.length > 4) {
      // Extract the last 4 digits
      const last4Digits = val.slice(-4);
      // Mask the rest of the phone number
      const maskedPart = 'XXX-XXX-';
      return maskedPart + last4Digits;
    } else {
      // Return the original value if it's too short
      return val;
    }
  }
  viewIncident: string = null;
  selectedLocations: { lat: number; lng: number }[] = [];
  onClickOpenMap() {
    const dialogRef = this._dialog.open(MapsLocationDialogComponent, {
      data: { header: 'Verification Location', isMultipleMarker: true },
    });
    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.selectedLocations = [];
        this.getLocationAddress(JSON.parse(x)).subscribe((response: any) => {
          if (response && response.results && response.results.length > 0) {
            const address = response.results[0].formatted_address;
            this.viewIncident = address;
            this.cdRef.detectChanges();
          }
        });

        this.selectedLocations.push(JSON.parse(x));
        this.createNewVisitorForm.controls['visitorLocation'].setValue(
          JSON.stringify(this.selectedLocations)
        );
      }
    });
  }
  getLocationAddress(val: any) {
    const lat = val.lat;
    const lng = val.lng;
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18'}`;

    return this.httpclient.get(geocodeUrl);
  }
  onChangeNumber(val: any) {
    this.createNewVisitorForm.controls.phoneNumber.setValue(
      this.phoneForm.value.phone
    );
  }
  isManuallyCheck = false;
  onDateChange(event: any) {
    this.createNewVisitorForm.controls['ePassValidity'].setValue(event.value);
  }
  onManualCheckVisitor() {
    let val: any = this.visitors[0];
    val['isManualCheckout'] = true;
    let baseServerURL = this.baseServerURL + 'UpdateVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .post(`${baseServerURL}`, val, {
        headers: httpOptions.headers,
        responseType: 'text',
      })
      .subscribe(
        (response: any) => {
          this.setInputField();
          this.isValid = true;
          this.isManuallyCheck = true;
          this.createNewVisitorForm.disable();
          this.createNewVisitorForm.controls.phoneNumber.setValue(
            this.phoneForm.value.phone
          );
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  searchedImage: string = null;
  setInputField() {
    console.log('setInputField', this.visitors[0]);

    this.searchedImage = this.visitors[0].profilePicture;
    this.visitorSelect(this.visitors);
  }
  onEditDetails() {
    this.isDisabled = false;
    this.createNewVisitorForm.enable();
    this.createNewVisitorForm.controls.isVerified.disable();
  }
  ScreenType = ScreenType;
}
